import reverse from "lodash/reverse";
import sortBy from "lodash/sortBy";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {KPICard} from "@/components/KPICard/KPICard.tsx";
import {shortDateTimeUser} from "@/lib/format.tsx";
import {GlobalAlertState} from "@/lib/types/alerting.ts";

interface StatHeaderAlertsProps {
  alerts: {
    items: GlobalAlertState[];
    total: number;
  };
}

export const StatHeaderAlerts = ({alerts}: StatHeaderAlertsProps) => {
  const {user} = useCurrentUserContext();

  const sortedAlerts = reverse(sortBy(alerts.items, (item) => item.created_at));

  return (
    <KPICard
      title={`Alerts${alerts.total > 0 ? `: Last: ${shortDateTimeUser(sortedAlerts[0].created_at.toString(), user!)}` : ""}`}
    >
      {alerts.total}
    </KPICard>
  );
};
